<template>
  <div>
  <v-dialog v-model="modifiersDialog" scrollable max-width="608px">
    <template v-slot:activator="{ on, attrs }" v-if="showButton">
      <div class="text-right">
      <v-btn
              dark
              v-bind="attrs"
              v-on="on"
      >
        Редактировать
      </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title>Добавить ингредиенты</v-card-title>
      <v-card-text >
        <v-expansion-panels>
          <v-expansion-panel
                  v-for="modifierCategory in modifierCategories"
                  :key="modifierCategory.id"
                  :id="modifierCategory.id"
          >
            <v-expansion-panel-header>{{modifierCategory.name}}</v-expansion-panel-header>
            <v-expansion-panel-content class="without-padding">
              <ul>
                  <li v-for="modifier in modifierCategory.modifiers" class="pl-6" @click="clickOnRow(modifier)" :class="{selected: modifier.selected}">
                    <div v-if="forProduct" class="modifier-item-wrapper">
                      <v-simple-checkbox
                              v-model="modifier.selected"
                      >
                      </v-simple-checkbox>
<!--                      <v-text-field @click.stop  v-show="modifier.count > 0" readonly :hide-details="true" :dense="true" v-model="modifier.count" outlined class="without-border">-->
<!--                        <v-icon slot="prepend" @click.stop="modifier.count&#45;&#45;">mdi-minus</v-icon>-->
<!--                        <v-icon slot="append" @click.stop="modifier.count++">mdi-plus</v-icon>-->
<!--                      </v-text-field>-->
                    </div>
                    <div v-else class="modifier-item-wrapper">
                      <v-simple-checkbox
                        v-model="modifier.selected"
                      >
                      </v-simple-checkbox>
                    </div>
                    <div class="name">{{ modifier.name }}</div>
                  </li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions>
        <v-btn block @click="update" :loading="loadingButton">Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          right
          top
  >
    {{ snackbarText }}
  </v-snackbar>
  </div>
</template>

<script>
  import Tabs from './Tabs'
  import ProductService from "../api/ProductService";
  import ModifierService from "../api/ModifierService";

  export default {
    name: 'ModifiersModal',
    props: {
      searchModifiers: String,
      modifierCategories: Array,
      showButton: {
        type: Boolean,
        default: true,
      },
      forProduct: {
          type: Boolean,
          default: true
      },
      // modifiers: Array
      value: Object,
    },
    components: {Tabs},
    data() {
      return {
        snackbar: false,
        timeout: 2000,
        snackbarText: '',
        snackbarColor: '',
        modifiersDialog: false,
        modifierGroup: {},
        product: this.value,
        loadingButton: false,
      };
    },
    methods: {
      init(item){
          this.modifiersDialog = true
          this.product = item
          let _this = this
          this.modifierCategories.forEach(function (category) {
              category.modifiers.forEach(function (modifier) {
                  if(_this.product.modifiers.find(mod => mod.id == modifier.id)){
                      modifier.selected = true;
                  } else {
                      modifier.selected = false
                  }
              })
          })
      },
      clickOnRow(modifier){
        modifier.selected = !modifier.selected

      },
      update() {
        var _this = this;
        this.loadingButton = true;
        if(this.forProduct){
          this.product.modifiers = [];
          this.modifierCategories.forEach(function (category) {
            category.modifiers.forEach(function (modifier) {
              if(modifier.selected){
                _this.product.modifiers.push(modifier)
              }
            })
          })

          ProductService.updateModifiers(this.product.id, this.product.modifiers).then(response => {
            this.product.modifiers = response.data.modifiers
            this.snackbar = true;
            this.snackbarText = 'Ингредиенты обновлены';
            this.snackbarColor = 'success';
          }).catch(error => {
            this.snackbar = true;
            this.snackbarText = 'Ошибка при обновлении ингредиентов';
            this.snackbarColor = 'error';
          }).finally(() => {
            this.loadingButton = false;
            this.modifiersDialog = false;
          });
        } else {
          this.product.modifiers = [];

          this.modifierCategories.forEach(function (category) {
            category.modifiers.forEach(function (modifier) {
              if(modifier.selected){
                _this.product.modifiers.push(modifier)
              }
            })
          })

          ModifierService.updateModifiersGroupModifier({id: this.product.id, items: this.product.modifiers}).then(response => {
            this.product.modifiers = response.data.modifiers
            this.snackbar = true;
            this.snackbarText = 'Ингредиенты обновлены';
            this.snackbarColor = 'success';
          }).catch(error => {
            this.snackbar = true;
            this.snackbarText = 'Ошибка при обновлении ингредиентов';
            this.snackbarColor = 'error';
          }).finally(() => {
            this.loadingButton = false;
            this.modifiersDialog = false;
          });
        }

      },
      recheck(){
        var _this = this
        if(this.forProduct){
          this.modifierCategories.forEach(function (category) {
            category.modifiers.forEach(function (modifier) {
              //console.log(modifier.id + ' = ' + )
              if(_this.product.modifiers.find(selectedModifier => selectedModifier.modifier_id == modifier.id)){
                modifier.selected = true
              } else {
                modifier.selected = false
              }
            })
          })
        }
      }
    },
    mounted() {
      this.recheck();

    },
    watch: {
      modifiersDialog() {
        this.recheck()
      },
      product(val) {

        this.$emit('input', val);
      }
    }
  }
</script>

<style lang="scss">
  .without-border {
    .v-input__slot{
      padding: 0!important;
    }
    .v-icon{
      width: 40px;
    }
    .v-input__prepend-outer{
      margin-right: 0;
    }
    .theme--light.v-icon:focus::after {
      opacity: 0;
    }
    input{
      text-align: center;
    }
    &.v-text-field--outlined{
      fieldset {
        border: none!important;
      }
    }
  }
  .without-padding .v-expansion-panel-content__wrap{
    padding: 0;
  }

</style>

<style lang="scss" scoped>

  ul{
    list-style-type: none;
    padding-left: 0;
    li{
      list-style-type: none;
      display: grid;
      grid-template-columns: 42px 1fr;
      margin-bottom: 8px;
      .modifier-item-wrapper{
        display: grid;
      }
      &.selected{
        background-color: #EEF8FF;
      }
      .name{
        line-height: 40px;
        color: #666;
        font-weight: 500;
        padding-left: 8px;
        font-size: 14px;
      }
    }
  }

</style>
